import { useGameSelector } from '../../GameStore';

import { GameResultType, PlayerWinResultType } from './types';

export const useMWStateSlice = {
  megaWinValue: (): any => {
    return useGameSelector(({ mwState }) => mwState.megawinValue);
  },
  getWinningAmount: (): PlayerWinResultType | null => {
    return useGameSelector(({ mwState }) => mwState.winingAmount);
  },
  getGameResult: (): GameResultType | null => {
    return useGameSelector(({ mwState }) => mwState.gameResult);
  },
  hideWinMessage: (): boolean => {
    return useGameSelector(({ mwState }) => mwState.hideWinMessage);
  },
};
